import axios from 'axios';
import { useQuery } from 'react-query';

import { QueryKeys } from '.';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';

export function useTeamMemberForDataRoomQuery(authToken: string, dataRoomGuid: string | null) {
	return useQuery(QueryKeys.IsDataRoomTeamMember(authToken, dataRoomGuid), () =>
		AxiosUtils.getResponseData(
			axios.get<boolean>(
				CerebroApiEndpoints.Absolute(CerebroApiEndpoints.Users.IsDataRoomTeamMember(dataRoomGuid)),
				{
					headers: {
						Authorization: `Bearer ${authToken}`,
					},
				}
			)
		)
	);
}
